import { MapContext } from 'contexts/MapContext';
import * as Styled from './styles';
import * as RiIcons from 'react-icons/ri';
import React, { useContext, useMemo, useEffect, useState } from 'react';
import { useLayers } from 'hooks/useLayers';

import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import VectorLayer from 'ol/layer/Vector';
import { ToolBox } from 'screens/Dashboard/components/SideBar/ToolBox';
import { BaseSelect } from 'components/BaseSelect';

function getName(str: string) {
  const key = 'p3m:';
  const index = str?.indexOf(key);
  return index !== -1 ? 'p3m:' + str?.slice(index + key.length) : '';
}

function getLayerId(layer: any): string {
  const props = layer?.getProperties?.() ?? {};
  if (layer instanceof VectorLayer && props.layertitle) return String(props.layertitle);
  if (props.uuid) return String(props.uuid);
  if (props.layertitle) return String(props.layertitle);
  return '';
}

export function SwipeMenu() {
  const { getLayerAttritubeByName } = useLayers();

  const {
    map,
    swipeLayer,
    handleSetSwipeLayer,
    swipeDirection,
    setSwipeDirection,
  } = useContext(MapContext);

  const [layersVersion, setLayersVersion] = useState(0);

  useEffect(() => {
    if (!map) return;

    const layers = map.getLayers();

    const onAdd = () => {
      setLayersVersion(v => v + 1);
    };

    layers.on('add', onAdd);

    return () => {
      layers.un('add', onAdd);
    };
  }, [map]);

  const availableLayers = useMemo(() => {
    if (!map) return [];

    return map
      .getLayers()
      .getArray()
      .filter((layer: any) => {
        const props = layer?.getProperties?.() ?? {};
        const hasId = !!(props.uuid || props.layertitle);
        if (!hasId) return false;

        return (
          layer instanceof TileLayer ||
          layer instanceof ImageLayer ||
          layer instanceof VectorLayer
        );
      });
  }, [map, layersVersion]);

  const selectedId = swipeLayer ? getLayerId(swipeLayer) : '';

  function getLayerLabel(layer: any) {
    const id = getLayerId(layer);
    const meta = getLayerAttritubeByName(getName(id))?.layertitle || id;

    if (layer instanceof VectorLayer) return `${meta.replace(/\.(kml|geojson|zip|shp)$/i, '')}`;
    if (layer instanceof TileLayer || layer instanceof ImageLayer)
      return `${meta} (camada do sistema)`;

    return meta;
  }

  return (
    <ToolBox
      header={
        <>
          <RiIcons.RiSplitCellsVertical />
          <span>Comparação</span>
        </>
      }
    >
      <Styled.SwipeGroup>
        <BaseSelect
          label={'Camada para comparar'}
          value={selectedId || 'disable'}
          onChange={handleSetSwipeLayer}
          placeholder={'Selecione a camada'}
          options={availableLayers.map(l => ({
            label: getLayerLabel(l),
            value: getLayerId(l),
          }))}
        />
      </Styled.SwipeGroup>

      <Styled.SwipeGroup>
        <label>Direção do deslize</label>

        <Styled.DirectionSelector>
          <Styled.DirectionButton
            active={swipeDirection === 'horizontal'}
            onClick={() => setSwipeDirection('horizontal')}
          >
            ↔ Horizontal
          </Styled.DirectionButton>

          <Styled.DirectionButton
            active={swipeDirection === 'vertical'}
            onClick={() => setSwipeDirection('vertical')}
          >
            ↕ Vertical
          </Styled.DirectionButton>
        </Styled.DirectionSelector>
      </Styled.SwipeGroup>
    </ToolBox>
  );
}